import { render, staticRenderFns } from "./BankPaymentForm.vue?vue&type=template&id=37aa2914"
import script from "./BankPaymentForm.vue?vue&type=script&lang=ts"
export * from "./BankPaymentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports